const id_common_report = {
    return_cus: {
        "": 'retur penjualan',
        total: 'total nominal retur penjualan',
    },
    return_sup: {
        "": 'retur pembelian',
        total: 'total nominal retur pembelian',
    },
    sales_commission: {
        "": "komisi sales",
        total: 'total komisi sales',
        label: {
            total: "total komisi"
        }
    },
    stock_price: {
        "": "Nilai Stok Barang",
        label: {
            nominal: "nilai barang",
            total_nominal: "total nilai barang",
        },
    },
    delivery: {
        "": "Pengiriman",
        label: {

        }
    },
    group: {
        "": "Group",
        label: {

        }
    }
}

export default id_common_report;